import React, { lazy } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { componentLoader } from '@nw/shared/utils';

import ProtectedRoute from '../components/ProtectedRoute';
import {
  LOGIN_ROUTE,
  NIAT_APPLICATION_PORTAL_HOME_ROUTE,
  ORDER_STATUS_CHECK_ROUTE_PATH
} from '../constants/RouteConstants';

const HomePageRoute = lazy(
  () =>
    componentLoader(
      () => import(/* webpackChunkName: "HomePageRoute" */ './HomepageRoute')
    ) as Promise<{ default: React.ComponentType<any> }>
);

const LoginPageRoute = lazy(
  () =>
    componentLoader(
      () => import(/* webpackChunkName: "LoginPageRoute" */ './LoginPageRoute')
    ) as Promise<{ default: React.ComponentType<any> }>
);

const OrderStatusCheckRoute = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "OrderStatusCheckRoute" */ '../components/OrderStatusCheckRoute'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

const FixedProtectedRoute = ProtectedRoute as any;

export const routes = [
  <Route
    exact
    path={LOGIN_ROUTE}
    key={'loginPage'}
    component={LoginPageRoute}
  />,
  <FixedProtectedRoute
    exact
    path={NIAT_APPLICATION_PORTAL_HOME_ROUTE}
    key="homePage"
    component={HomePageRoute}
  />,
  <FixedProtectedRoute
    exact
    path={ORDER_STATUS_CHECK_ROUTE_PATH}
    key={ORDER_STATUS_CHECK_ROUTE_PATH}
    component={OrderStatusCheckRoute}
  />,
  <Route
    path="*"
    render={({ location }) => (
      <Redirect
        to={{
          pathname: NIAT_APPLICATION_PORTAL_HOME_ROUTE,
          search: location.search
        }}
      />
    )}
  />
];
